export { default } from './Pill';
